export default __webpack_public_path__ + "static/hotblack-coffee-hero-6a39b750835d78430a7961141b2b24e6.jpg";